import React from 'react';
import { number, func } from 'prop-types';
import _debounce from 'lodash/debounce';
import { Input } from '@tesla/informed-tds';

const DebounceInput = ({ debounceTimeout, maxWait, onDelayedChange, ...otherProps }) => {
  const handleChange = _debounce(({ value }) => onDelayedChange(value), debounceTimeout, maxWait);
  return <Input onChange={handleChange} {...otherProps} />;
};

DebounceInput.propTypes = {
  debounceTimeout: number,
  maxWait: number,
  onDelayedChange: func,
};

DebounceInput.defaultProps = {
  debounceTimeout: 100,
  maxWait: 1000,
  onDelayedChange: () => {},
};

export default DebounceInput;
